import React from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  FormGroup,
  Form,
  Label,
  Row,
  Col,
} from 'reactstrap'
import moment from '../../../../lib/moment.js'
import get from 'lodash/get'
import styled from 'styled-components'
import { statusColor, approveStatus } from '../../helpers/color'

class InformationModal extends React.Component {
  isEmpty = (text) => {
    return text && text !== '' ? text : '-'
  }
  render() {
    const myTimesheet = get(this.props, 'myTimesheet')
    const status = approveStatus(get(myTimesheet, 'timesheet.status'))
    const color = statusColor(status)
    const submitedDate = get(myTimesheet, 'timesheet.submitedDate')
    const submitedDateString = submitedDate ? moment(submitedDate).format('DD-MM-YYYY') : '-'
    const approvedDate = get(myTimesheet, 'timesheet.approvedDate')
    const approvedDateString = approvedDate ? moment(approvedDate).format('DD-MM-YYYY') : '-'
    const remark = get(myTimesheet, 'timesheetSubmitRequest.remark_request_user')
    return (
    /* eslint no-underscore-dangle: 0 */
      <Modal
        isOpen={ get(this.props, 'open') }
        toggle={ get(this.props, 'toggle') }
      >
        <HeaderForm toggle={ get(this.props, 'toggle') }>
          <HeadLabel>Timesheet Information</HeadLabel>
        </HeaderForm>
        <ModalBody>
          <Row>
            <Col sm="12">
              <Form >
                <FormGroup>
                  <Container >
                    <LabelTextInfo>Status</LabelTextInfo>
                    <Row >
                      <ColDataInfo>
                        <Detail color={ color }>{ status }</Detail>
                      </ColDataInfo>
                    </Row>
                    <LabelTextInfo>Submitted Date</LabelTextInfo>
                    <Row >
                      <ColDataInfo>
                        { submitedDateString }
                      </ColDataInfo>
                    </Row>
                    <LabelTextInfo>Approved Date</LabelTextInfo>
                    <Row >
                      <ColDataInfo>
                        { approvedDateString }
                      </ColDataInfo>
                    </Row>
                    <LabelTextInfo>Submit Remark</LabelTextInfo>
                    <Row >
                      <ColDataInfo>
                        { remark === '' || remark === null || remark === undefined ? '-' : remark }
                      </ColDataInfo>
                    </Row >
                  </Container>
                </FormGroup>
              </Form>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter />
      </Modal>
    )
  }
}

export default InformationModal

const HeaderForm = styled(ModalHeader)`
  font-family: 'Gotham-Bold' !important;
  font-size: 12px ;
`
const HeadLabel = styled(Label)`
  font-family: 'Gotham-Bold' !important;
  font-size: 16px ;
  color: #AD2624;
  margin-left: 5px;
`
const LabelTextInfo = styled(Label)`
  font-family: 'Gotham-Bold' !important;
  font-size: 14px ;
  margin-bottom: 1%;
`
const ColDataInfo = styled(Col)`
  font-family: 'Gotham' !important;
  font-size: 14px ;
`
const Detail = styled.span`
  margin-right: 10px;
  font-size: 12px;
  color: ${props => props.color};
`



// WEBPACK FOOTER //
// ./src/components/timesheet/tab-content/my-timesheet/info-modal.js